import React, { useRef } from "react";
import { useDrop } from "react-dnd";

import AppConstants from "../../../constants/AppConstants";
import { generateDropSpec } from "../../../utils/DnDUtils";
import { pagePanelDrop } from "../SitePanelDropHandlers";
import { CANVAS_SET_BLOCK_LAYER_ITEM } from "../../../constants/DnDConstants";
import EmptyLayer from "./EmptyLayer";

const { DROP_BORDER, ITEM_TYPE_CANVAS_SET_BLOCK } = AppConstants;

/**
 * Create a drop area for LayerPanelCanvasSetBlock when another one doesn't exist to drop onto.
 */
const LayerPanelCanvasSetDropMarker = ({ canvasSet, height, index }) => {
  const selfRef = useRef();

  const drop = generateDropSpec({
    type: CANVAS_SET_BLOCK_LAYER_ITEM,
    onDrop: pagePanelDrop({
      areaOverride: "top",
      canvasSet,
      dropRef: selfRef.current,
      id: "",
      index,
      layerType: ITEM_TYPE_CANVAS_SET_BLOCK,
    }),
  });

  const [{ isOver }, dropRef] = useDrop(drop);
  const style = {
    height: height || "initial",
  };

  isOver && (style.borderTop = DROP_BORDER);

  return (
    <div
      style={style}
      className="layer-block-wrapper canvas-set-drop-marker"
      ref={(self) => {
        selfRef.current = self;
        dropRef(self);
      }}
    >
      <EmptyLayer />
    </div>
  );
};

export default LayerPanelCanvasSetDropMarker;
